import { getContentForPage, getSEOForPage, getScriptForPage } from "@lib/wordpress";
import { useEffect } from "react";
import { useRouter } from "next/router";
import styles from './style.module.css'
import WordpressStyle from "pagecomponents/WordpressStyle";
import Head from "next/head";

export default function Wordpress({ html, gblock, seo, script }) {
    const router = useRouter()
    useEffect(() => {
        const scriptElement = document.createElement('script');
        scriptElement.type = 'application/ld+json';
        console.log('script: ', script)
        scriptElement.textContent = script;
        document.head.appendChild(scriptElement);        

      setTimeout(() => {
          if (!router.asPath.includes('#')) {
            window.scrollTo(0, 0);
          }
      }, 300);

      return () => {
        document.head.removeChild(scriptElement);
      }
    }, []);
    
    return (
        <div id="wordpress" className={`${styles.wordpress} ${gblock ? "gblock" : ""}`}>  
            <WordpressStyle />
            <CustomMeta seo={seo} />
            <div dangerouslySetInnerHTML={{ __html: html }} className={styles.content} />
        </div>
    )
}

function CustomMeta({ seo }) {  
    return (
        <Head>
            <title>{seo?.title}</title>
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content={seo?.opengraphType} />
            <meta property="og:title" content={seo?.opengraphTitle} />
            <meta property="og:url" content={seo?.opengraphUrl} />
            <meta property="og:site_name" content={seo?.opengraphSiteName} />
            <meta property="article:modified_time" content={seo?.opengraphModifiedTime} />
            <meta property="og:image" content={seo?.opengraphImage?.link} />
            <meta property="og:description" content={seo?.opengraphDescription} />

            {/* Question: it seems like some of these tags are strange */}
            <meta name="twitter:card" content={"summary_large_image"} />            
            <meta name="twitter:label1" content={"Est. reading time"} />            
            <meta name="twitter:data1" content={seo?.readingTime} />                        
        </Head>
    )
}

export function wordPressStaticProps(id) {
    return async () => {
        let html;
        let seo = {}
        let script;

        try {
            html = await getContentForPage(id);
            seo = await getSEOForPage(id);
            script = await getScriptForPage(id);
        } catch (e) {
            console.log('e: ', e)
        }

        // console.log('script: ', script)
        console.log(seo)

        return {
            props: {
                html,
                seo, 
                script
            },
            revalidate: 30
        }
    }
}